import { render, staticRenderFns } from "./YesOrNo.vue?vue&type=template&id=29e49e90&lang=pug&"
import script from "./YesOrNo.vue?vue&type=script&lang=ts&"
export * from "./YesOrNo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports